import { get, post } from './index';

const enrich = dto => {
    dto.scheduled.forEach(scheduled => {
        scheduled.employee.fullName = `${scheduled.employee.firstName} ${scheduled.employee.lastName}`;
    });
    return dto;
}

export const getScheduledDTO = async () => {
    let dto = await get(`/scheduled`);
    return enrich(dto)
}

export const scheduleEmployeeUpdate = async (employee) => {
    return await post(`/schedule_employee_update`, {
        id: employee.id,
        firstName: employee.firstName,
        lastName: employee.lastName,
        email: employee.email,
        title: employee.title,
        level: employee.level,
        practiceName: employee.practiceName,
        capability: employee.capability,
        locationName: employee.locationName,
        employment_status: employee.employment_status,
        contractorRate: employee.contractorRate != null && employee.contractorRate !== "" ? parseFloat(employee.contractorRate) : null,
        manager: employee.manager,
        careerCoach: employee.careerCoach,
        startDate: employee.startDate,
        termDate: employee.termDate,
        effectiveDate: employee.effectiveDate,
        ptoPolicy: employee.ptoPolicy,
        ptoModifier: employee.ptoModifier === "" || employee.ptoModifier == null ? null : parseFloat(employee.ptoModifier),
        ptoHoursOverride: employee.ptoHoursOverride === "" || employee.ptoHoursOverride == null ? null : parseFloat(employee.ptoHoursOverride),
    });
};

export const updateScheduled = async (id, data) => {
    return await post(`/scheduled_update`, { id, ...data });
};

export const deleteScheduled = async (id) => {
    return await post(`/scheduled_delete`, { id });
};

